module.exports = __webpack_public_path__ + "4840214dd9231660c6dbcf8ebb38de7d.svg";